'use client';
import Box from '@mui/material/Box';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import { useTheme } from '@mui/material/styles';
import { useMemo } from 'react';

/**
 * 市町選択コンポーネント
 */
type Props = {
  cityDomain: string | null;
  setCityDomain: (cityDomain: string | null) => void;
  customerSetting: IbarakiRegionSetting;
};

export const CitySelect: React.FC<Props> = ({
  cityDomain,
  setCityDomain,
  customerSetting
}) => {
  const theme = useTheme();
  const cities = useMemo(() => {
    return Object.entries(customerSetting.cities)
      .sort((a, b) => a[1].cityId - b[1].cityId)
      .map(([domain, city]) => ({
        domain,
        cityName: city.cityName
      }));
  }, [customerSetting.cities]);

  return (
    <>
      <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
        <InputLabel
          id="searchbox-city-label"
          htmlFor="searchbox-city"
          sx={theme.typography.body2}
        >
          市町村で絞り込む
        </InputLabel>
      </Box>
      <Select
        labelId="searchbox-city-label"
        fullWidth
        size="small"
        inputProps={{
          id: 'searchbox-city',
          sx: {
            color: cityDomain === null ? theme.palette.text.disabled : undefined
          }
        }}
        value={cityDomain === null ? 'null' : cityDomain}
        onChange={(e) => {
          if (e.target.value === 'null') {
            setCityDomain(null);
          } else {
            setCityDomain(e.target.value);
          }
        }}
      >
        <MenuItem value="null">市町村を選択</MenuItem>
        {cities.map(({ domain, cityName }) => (
          <MenuItem key={domain} value={domain}>
            {cityName}
          </MenuItem>
        ))}
      </Select>
    </>
  );
};
